/* CONTEXT */

//Import the libraries
import React , { useState, createContext } from "react";


//Holds the logged status of the user
export const LoggedContext = createContext()
//Holds the information about the the help Tooltips activation
export const HelpActivatedContext = createContext()
//Holds the full info of the user
export const DataContext = createContext()
//The info of the selected prescription unit
export const UnitContext = createContext()
//The info of the spending limits of the user --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const LimitContext = createContext()
//Holds information about the "χρεωμένες επισκέψεις" --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const QuotaContext = createContext()
//The patient info --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const PatientInfoContext = createContext()
//Holds info about the application parameters status (activated / disactivated)
export const ParametersContext = createContext()
//The full info of all the medicines (used in the autocomplete) 
export const MedicinesAutocompleteContext = createContext()
//The full info of all the exams (masterdata, used in the autocomplete) 
export const ExamsAutocompleteContext = createContext()
//All the diagnoses (full info)
export const DiagnosisAutocompleteContext = createContext()
//The selected insurance for the visit --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const InsuranceContext = createContext()
//The protocols inserted in the past to the patient --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const PatientProtocolHistoryContext = createContext()
//The doses options (masterdata)
export const DosesContext = createContext()
//The frequencies options (masterdata)
export const FrequenciesContext = createContext()
//The percentages options (masterdata)
export const PercentagesContext = createContext()
//The repeats options (masterdata)
export const RepeatsContext = createContext()
//The Nonincases options (case where the patient has 0% copayment) (masterdata)
export const NonincasesContext = createContext()
//The high risk groups options (in vaccines) (masterdata)
export const HighriskgroupContext = createContext()
//The full information of the medications the user prescribed (arrray of objects) --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const MedicationRegisteredContext = createContext()
//Icpc2 (masterdata)
export const Icpc2Context = createContext()
//Specialities (masterdata)
export const SpecialitiesContext = createContext()
//The non participation cases for the prescription (masterdata)
export const PrescriptionsNonParticipationCasesContext = createContext()
//The referal no participation cases (masterdata)
export const ExamsNonParticipationCasesContext = createContext()
//The visit id --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const VisitIdContext = createContext() 
//The refferal type (masterdata)
export const RefferalTypesContext = createContext()
//The full information of the exams the user prescribed (arrray of objects)
export const ExamsRegisteredContext = createContext()
//The comment of the refferal (free text)
export const ReferralCommentFinalContext = createContext()
//The zero case partecipation type --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const ExamZeroCaseContext = createContext()
//The zero case partecipation date (in case of zero case that needs date)
export const ZeroCaseDateContext = createContext()
//The zero case partecipation descision number (in case of zero case that needs descision number) --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const ZeroCaseNumberContext = createContext()
//The registered refferals in the visit --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const RegisteredRefferalsContext = createContext()
//The exam packages of the user
export const UserExamPackagesContext = createContext()
//The refference types (masterdata)
export const ResponseReferenceToContext = createContext()
//Specialities (masterdata)
export const ResponseSpecialitiesContext = createContext()
//Icpc2 (masterdata)
export const ResponseIcpc2Context = createContext()
//The corellation between unit type and accepted refference types (masterData)
export const ResponseUnitTypeContext = createContext()
//The prescriptions the user prescribed (arrray of objects) --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const PrescriptionRegisteredContext = createContext()
//The medicines SPC data (masterdata)
export const spcContext = createContext()
//The medicine diseases data
export const diseasesContext = createContext()
//The contarindications of the medicines (mastedata)
export const contraindicationsContext = createContext()
//The list of the HDIKA prescription overrides for the user to select (masterdata)
export const overrideContext = createContext()
//Holds the recomendation information --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const recomendationInfoContext = createContext() 
//Holds the uninsured exeptions for the user to choose 
export const uninsuredExeptionsContext = createContext() 
//Holds the uninsured exeptions the user choosed for the patient --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const uninsuredExeptionChosenContext = createContext() 
//Holds the suggested medicines for the doctor + the chronic medicines of the patient --- MUST RESET WHEN CLOSE OR CANCEL VISIT---
export const medicinesSuggestedContext = createContext() 
//Holds the day intervals in the prescriptions repeat
export const repeatIntervalsContext = createContext() 
//Holds the DHPC data
export const DhcpContext = createContext() 
//Holds the helper steps for the Joyride component
export const HelperStepsContext = createContext() 
//Holds the medicines that are ins hortage
export const MedicinesShortageContext = createContext() 
//if the visit is a proactive one the value is "true" if not "false"
export const ProactiveContext = createContext() 


//DataProvider is the database of the app. Contains all the states(information) of every component in the app.
export const DataProvider1 =props=>{

    //The state we want the provider to hold
    const [doctorInformation, setDoctorInformation ]= useState({data:null})
    const [logged, setLogged] = useState(false)
    const [helpActivated, setHelpActivated] = useState(false)
    const [parameters, setParameters] = useState()
    const [steps, setSteps] = useState({
        status:false,
        data:[]
    })

    //In the return we pass the value to all the other components
    return (  
        <HelpActivatedContext.Provider value={[helpActivated, setHelpActivated]}>
            <HelperStepsContext.Provider value={[steps, setSteps]}>
                <LoggedContext.Provider value={[logged, setLogged]}>
                    <DataContext.Provider value={[doctorInformation, setDoctorInformation]}>  
                        <ParametersContext.Provider value={[parameters, setParameters]}>
                            {props.children}
                        </ParametersContext.Provider>
                    </DataContext.Provider>
                </LoggedContext.Provider>
            </HelperStepsContext.Provider>
        </HelpActivatedContext.Provider>
    )
}
export const DataProvider3 =props=>{

    const [selectedUnit, setSelectedUnit] = useState(null)
    const [limitInfo,setLimitInfo] = useState(null)
    const [quotaInfo,setQuotaInfo] = useState(null)
   
    return(
        <LimitContext.Provider value={[limitInfo,setLimitInfo]}>
            <UnitContext.Provider value={[selectedUnit, setSelectedUnit]}>
                <QuotaContext.Provider value={[quotaInfo,setQuotaInfo]}>  
                    {props.children}
                </QuotaContext.Provider>
            </UnitContext.Provider>
        </LimitContext.Provider>
    )
}
export const DataProvider4 =props=>{

    const [patientInfo, setPatientInfo] = useState()
    const [selectedInsurance,setSelectedInsurance] = useState(null)
    const [visitId,setVisitId] = useState("")
    const [patientProtocols, setPatientProtocols] = useState({loading:false, info:[]})
    const [proactive, setProactive] = useState({
        open:false,
        data:null
    })




    return(
        <ProactiveContext.Provider value={[proactive, setProactive]}>
            <VisitIdContext.Provider value={[visitId,setVisitId]}>
                <InsuranceContext.Provider value={[selectedInsurance,setSelectedInsurance]}>
                    <PatientInfoContext.Provider value={[patientInfo, setPatientInfo]}>
                        <PatientProtocolHistoryContext.Provider value={[patientProtocols, setPatientProtocols]}>
                            {props.children}
                        </PatientProtocolHistoryContext.Provider>
                    </PatientInfoContext.Provider>
                </InsuranceContext.Provider>
            </VisitIdContext.Provider>
        </ProactiveContext.Provider>
    )
}
export const DataProvider6 =props=>{

    const [medicines, setMedicines] = useState([])
    const [exams, setExams] = useState()
    const [diagnosis, setDiagnosis] = useState()
    const [icpc2, setIcpc2] = useState()
    const [specialities, setSpecialities] = useState()
    const [dose, setDoses] = useState()
    const [frequencies, setFrequencies] = useState()
    const [percentages, setPercentages] = useState()
    const [repeats, setRepeats] = useState()
    const [nonInCases, setNonInCases] = useState()
    const [highRiskGroup, setHighRiskGroup] = useState()
    const [prescriptionsNonParticipationCases, setPrescriptionsNonParticipationCases] = useState()
    const [examsNonParticipationCases, setExamsNonParticipationCases] = useState()
    const [refferalTypes, setREfferalTypes] = useState()
    const [userExamPackages, setUserExamPackages] = useState([])
    const [responseReferenceTo, setResponseReferenceTo] = useState([])
    const [responseSpecialities, setResponseSpecialities] = useState([])
    const [responseIcpc2, setResponseIcpc2] = useState([])
    const [responseUnitType, setResponseUnitType] = useState([])
    const [spc, setSpc] = useState([])
    const [disease, setDiseades] = useState([])
    const [contraindications, setContraindications] = useState([])
    const [prescriptionOverrideData, setprescriptionOverrideData] = useState([])
    const [uninsuredExeptions, setUninsuredExeptions] = useState([])
    const [repeatIntervals, setRepeatIntervals] = useState([])
    const [medicinesShortage, setMedicinesShortage] = useState([])
    const [recomendationInfo, setRecomendationInfo] = useState({
        status:0,
        info:{
            amka: null,
            firstName: "",
            lastName: "",
            specialty: ""
        },
        date:null,
        dateShow:'',
        dateApi:''
    })
    const [medicinesSuggested, setMedicinesSuggested] = useState({
        loaded:false,
        loading:false,
        medicinesData:[],
        chronicMeds:[],
        diagnosisData:[]
    })
    const [selectedUninsuredExeptions, setSelectedUninsuredExeptions] = useState({
		"id": 1000,
		"description": "",
		"isActive": true,
		"ordinal": 0
	})
    const [dhpc, setDhpc] = useState({
        info:[],
        loaded:false
    })
    
    
    return(   
        <MedicinesShortageContext.Provider value={[medicinesShortage, setMedicinesShortage]}>
            <DhcpContext.Provider value={[dhpc, setDhpc]}>
                <repeatIntervalsContext.Provider value={[repeatIntervals, setRepeatIntervals]}>
                    <medicinesSuggestedContext.Provider value={[medicinesSuggested, setMedicinesSuggested]}>
                        <uninsuredExeptionChosenContext.Provider value={[selectedUninsuredExeptions, setSelectedUninsuredExeptions]}>
                            <uninsuredExeptionsContext.Provider value={[uninsuredExeptions, setUninsuredExeptions]}>
                                <recomendationInfoContext.Provider value={[recomendationInfo, setRecomendationInfo]}>
                                    <overrideContext.Provider value={[prescriptionOverrideData, setprescriptionOverrideData]}>
                                        <contraindicationsContext.Provider value={[contraindications, setContraindications]}>
                                            <diseasesContext.Provider value={[disease, setDiseades]}>
                                                <spcContext.Provider value={[spc, setSpc]}>
                                                    <UserExamPackagesContext.Provider value={[userExamPackages, setUserExamPackages]}>
                                                        <ResponseReferenceToContext.Provider value={[responseReferenceTo, setResponseReferenceTo]}>
                                                            <ResponseSpecialitiesContext.Provider value={[responseSpecialities, setResponseSpecialities]}>
                                                                <ResponseIcpc2Context.Provider value={[responseIcpc2, setResponseIcpc2]}>
                                                                    <ResponseUnitTypeContext.Provider value={[responseUnitType, setResponseUnitType]}>
                                                                        <RefferalTypesContext.Provider value={[refferalTypes, setREfferalTypes]}>
                                                                            <SpecialitiesContext.Provider value={[specialities, setSpecialities]}>
                                                                                <Icpc2Context.Provider value={[icpc2, setIcpc2]}>
                                                                                    <DosesContext.Provider value={[dose, setDoses]}>
                                                                                        <FrequenciesContext.Provider  value={[frequencies, setFrequencies]}>
                                                                                            <PercentagesContext.Provider value={[percentages, setPercentages]}>
                                                                                                <RepeatsContext.Provider value={[repeats, setRepeats]}>
                                                                                                    <NonincasesContext.Provider value={[nonInCases, setNonInCases]}>
                                                                                                        <HighriskgroupContext.Provider value={[highRiskGroup, setHighRiskGroup]}>
                                                                                                            <DiagnosisAutocompleteContext.Provider value={[diagnosis, setDiagnosis]}>
                                                                                                                <ExamsAutocompleteContext.Provider value={[exams, setExams]}>
                                                                                                                    <MedicinesAutocompleteContext.Provider value={[medicines, setMedicines]}>
                                                                                                                        <PrescriptionsNonParticipationCasesContext.Provider value={[prescriptionsNonParticipationCases, setPrescriptionsNonParticipationCases]}>
                                                                                                                            <ExamsNonParticipationCasesContext.Provider value={[examsNonParticipationCases, setExamsNonParticipationCases]}>
                                                                                                                                {props.children}
                                                                                                                            </ExamsNonParticipationCasesContext.Provider>
                                                                                                                        </PrescriptionsNonParticipationCasesContext.Provider>
                                                                                                                    </MedicinesAutocompleteContext.Provider>
                                                                                                                </ExamsAutocompleteContext.Provider>
                                                                                                            </DiagnosisAutocompleteContext.Provider>
                                                                                                        </HighriskgroupContext.Provider>
                                                                                                    </NonincasesContext.Provider>
                                                                                                </RepeatsContext.Provider>
                                                                                            </PercentagesContext.Provider>
                                                                                        </FrequenciesContext.Provider>
                                                                                    </DosesContext.Provider>
                                                                                </Icpc2Context.Provider>
                                                                            </SpecialitiesContext.Provider>
                                                                        </RefferalTypesContext.Provider>                                
                                                                    </ResponseUnitTypeContext.Provider>
                                                                </ResponseIcpc2Context.Provider>
                                                            </ResponseSpecialitiesContext.Provider>
                                                        </ResponseReferenceToContext.Provider>
                                                    </UserExamPackagesContext.Provider>
                                                </spcContext.Provider>
                                            </diseasesContext.Provider>
                                        </contraindicationsContext.Provider>
                                    </overrideContext.Provider>
                                </recomendationInfoContext.Provider>
                            </uninsuredExeptionsContext.Provider>
                        </uninsuredExeptionChosenContext.Provider>
                    </medicinesSuggestedContext.Provider>
                </repeatIntervalsContext.Provider>
            </DhcpContext.Provider>
        </MedicinesShortageContext.Provider>
    )
}
export const DataProvider9 =props=>{

    const [medicationRegistered, setMedicationRegister] = useState([])
    const [examsRegistered, setexamsRegister] = useState([])
    const [registeredRefferals, setRegisteredRefferals] = useState([])
    const [prescriptions, setPrescriptions] = useState([])
    
    
    return(
        <PrescriptionRegisteredContext.Provider value={[prescriptions, setPrescriptions]}>
 
                <RegisteredRefferalsContext.Provider value={[registeredRefferals, setRegisteredRefferals]}>    
                    <MedicationRegisteredContext.Provider value={[medicationRegistered, setMedicationRegister]}>     
                        <ExamsRegisteredContext.Provider value={[examsRegistered, setexamsRegister]}>     
                            {props.children}
                        </ExamsRegisteredContext.Provider>
                    </MedicationRegisteredContext.Provider>
                </RegisteredRefferalsContext.Provider>
    
        </PrescriptionRegisteredContext.Provider>
    )
}
export const DataProvider10 =props=>{

    const [referralCommentFinal, setReferralCommentFinal] = useState('Παρακλινικός έλεγχος')
    const [examZeroCase, setExamZeroCase] = useState({
        id: '',
        isActive: null,
        needsDecision: null,
        noParticipationCase: '',
        _id: ''})
    const [zeroCaseDate, setZeroCaseDate] = useState('')
    const [zeroCaseNumber, setZeroCaseNumber] = useState('')
    

    return(   
        <ReferralCommentFinalContext.Provider value={[referralCommentFinal, setReferralCommentFinal]}>     
            <ExamZeroCaseContext.Provider value={[examZeroCase, setExamZeroCase]}>     
                <ZeroCaseDateContext.Provider value={[zeroCaseDate, setZeroCaseDate]}>     
                    <ZeroCaseNumberContext.Provider value={[zeroCaseNumber, setZeroCaseNumber]}>     
                        {props.children}
                    </ZeroCaseNumberContext.Provider>
                </ZeroCaseDateContext.Provider>
            </ExamZeroCaseContext.Provider>
        </ReferralCommentFinalContext.Provider>
    )
}

